<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>

              <CTab :title="$t('acceptedRequest')">
                <AcceptedOrderListProducts/>
              </CTab>
              <CTab :title="$t('sidebars.addOrder')">
                <BuyOrders/>
              </CTab>
              <CTab :title="$t('ordersInWay')">
                <InWayOrders/>
              </CTab>
              <CTab :title="$t('RequestedPurchaseList')">
                <BuyLists/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BuyLists from '../accounting/BuyLists'
import BTabs from "../../tabs/BTabs";

import AcceptedOrderListProducts from "@/views/panel/orders/AcceptedOrderListProducts";
import BuyOrders from "@/views/panel/orders/BuyOrders";
import InWayOrders from "@/views/panel/orders/InWayOrders";
import PurchaseReturn from "./PurchaseReturn";
export default {
  name: 'Login',
  components: {
    BTabs,
    AcceptedOrderListProducts,
    BuyOrders,
    PurchaseReturn,
    InWayOrders,
    BuyLists
  },
  data() {
    return {

    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
